
// app/i18n/translation-storage.ts
import { getDict, putDict } from './indexeddb-i18n';

export async function getStoredVersion(lang: string): Promise<string | null> {
  try {
    const entry = await getDict(lang);
    return entry?.version ?? null;
  } catch {
    return null;
  }
}

export async function getStoredPayload(lang: string): Promise<Record<string, any> | null> {
  try {
    const entry = await getDict(lang);
    return entry?.translations ?? null;
  } catch {
    return null;
  }
}

export async function storeDictionary(
  lang: string,
  version: string,
  translations: Record<string, any>
): Promise<void> {
  try {
    await putDict(lang, version, translations);
  } catch {
    // Silencioso: se IndexedDB falhar, o loader cairá para assets.
  }
}

// Comparação "semver-like": ex. "2025.12.01" > "2025.11.30"
export function isRemoteNewer(local: string | null, remote: string): boolean {
  if (!remote) return false;
  if (!local) return true;
  const a = local.split('.').map((n) => Number(n));
  const b = remote.split('.').map((n) => Number(n));
  const len = Math.max(a.length, b.length);
  for (let i = 0; i < len; i++) {
    const ai = a[i] ?? 0;
    const bi = b[i] ?? 0;
    if (bi > ai) return true;
    if (bi < ai) return false;
  }
  return false;
}
